export default __webpack_public_path__ + "static/media/focus-on-mental.23066100.svg";